import React from 'react';
import { useFormContext } from 'react-hook-form';
import { AlertCircle } from 'lucide-react';
import ImagemPergunta from './ImagemPergunta';

const PerguntaAberta = ({ pergunta, indice }) => {
  const { register, formState: { errors } } = useFormContext();
  const fieldName = `respostas.${pergunta.id}`;
  const erro = errors?.respostas?.[pergunta.id];

  return (
    <div className="card">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">
        {indice}. {pergunta.texto}
        {pergunta.obrigatoria && <span className="text-red-500 ml-1">*</span>}
      </h3>

      <ImagemPergunta imagemPath={pergunta.imagem_path} />

      <textarea
        {...register(fieldName, pergunta.obrigatoria ? { required: 'Este campo é obrigatório' } : {})}
        className="input-field"
        rows={3}
        placeholder="Escreva sua resposta..."
      />

      {erro && (
        <p className="mt-3 text-sm text-red-600 flex items-center gap-1">
          <AlertCircle className="w-4 h-4" /> {erro.message}
        </p>
      )}
    </div>
  );
};

export default PerguntaAberta;
